import Cookies from "js-cookie";

export const ROLES = {
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
  VOLUNTEER: "VOLUNTEER",
  WAREHOUSE: "WAREHOUSE",
  CONTRACTOR: "CONTRACTOR",
  CUSTOMER: "CUSTOMER",
};

export const getRole = (): string => Cookies.get("role") || "";

export const isSuperAdmin = (): boolean => getRole() === ROLES.SUPER_ADMIN;

export const hasRole = (...roles: string[]): boolean =>
  roles.includes(getRole());

export const clearAuth = () => {
  Cookies.remove("access_token");
  Cookies.remove("role");
};
